const NETWORK_STATUS = {
  OFFLINE: 'offline', // 离线状态，networkType为none和unknown（表示小程序无法确定当前的网络类型。这可能是由于小程序无法获取到网络状态的相关信息，或者在获取网络类型时出现了错误或异常情况。通常，这种情况下建议用户检查网络连接，确保设备已连接到网络并且网络正常工作。）
  POOR: 'poor', // networkType为2g、3g的情况认为是弱网，加载图片超过1500则表示poor
  GOOD: 'good', // 加载图片小于1500表示网络极好good
}

const NETWORK_TYPE = {
  OFFLINE: ['unknown', 'none', 'offline'],
  POOR: ['2g', '3g'],
}

const DOWNLOAD_TIME = [1500] // 小于1500则表示网络good 超过1500表明是弱网。
const MAX_COUNT = 3 // 最大重试次数
let count = 0 // 当前重试次数

// 获取网络类型
function getNetworkType() {
  return new Promise((resolve) => {
    wx.getNetworkType({
      success(res) {
        resolve(res)
      },
      fail(err) {
        resolve(err)
      },
    })
  })
}
/**
 * @param opt 可选
 * 根据getNetworkType返回的networkType，以及请求图片的时长判断当前网络请求情况
 * @returns 网络状态，返回NETWORK_STATUS中的值
 */
const getNetworkStatus = (opt) => {
  return new Promise((resolve) => {
    try {
      let networkStatus = NETWORK_STATUS.GOOD
      // 返回网络状态
      const handleNetWork = (networkType) => {
        if (NETWORK_TYPE.OFFLINE.includes(networkType)) {
          emitNetworkStatus(NETWORK_STATUS.OFFLINE)
          return resolve(NETWORK_STATUS.OFFLINE)
        }
        if (NETWORK_TYPE.POOR.includes(networkType)) {
          emitNetworkStatus(NETWORK_STATUS.POOR)
          return resolve(NETWORK_STATUS.POOR)
        }
        const startTime = +new Date()
        // 非NETWORK_TYPE中定义的状态就请求图片获取网络状态
        requestImage().then(() => {
          const requestTime = +new Date() - startTime

          if (requestTime < DOWNLOAD_TIME[0]) {
            networkStatus = NETWORK_STATUS.GOOD
          } else if (requestTime > DOWNLOAD_TIME[0]) {
            networkStatus = NETWORK_STATUS.POOR
          }
          emitNetworkStatus(networkStatus)
          return resolve(networkStatus)
        })
      }
      // onNetworkStatusChange中获取的networkType
      if (opt && opt.networkType) {
        handleNetWork(opt.networkType)
      } else {
        getNetworkType().then(({ networkType }) => {
          handleNetWork(networkType)
        })
      }
    } catch (error) {
      resolve(NETWORK_STATUS.GOOD)
    }
  })
}

// 弱网给出toast提示
function handleNetWorkStatus(networkStatus) {
  if (networkStatus === NETWORK_STATUS.POOR) {
    uni.showToast({
      title: '网络信号较弱，请耐心等待',
      duration: 1000,
      icon: 'none',
    })
  }
}

function run() {
  if (count >= MAX_COUNT) {
    return
  }
  const timer = setTimeout(() => {
    getNetworkStatus().then((networkStatus) => {
      count += 1
      if ([NETWORK_STATUS.POOR].includes(networkStatus)) {
        run()
      }
    })
    clearTimeout(timer)
  }, 5000)
}

function start(opt) {
  console.log('这是监控开始')
  const timer = setTimeout(() => {
    getNetworkStatus(opt).then((networkStatus) => {
      if ([NETWORK_STATUS.POOR].includes(networkStatus)) {
        run()
      }
      // 重试周期内只处理一次
      handleNetWorkStatus(networkStatus)
    })

    clearTimeout(timer)
  }, 1000)
}

// 发起图片网络请求，获取响应的时间判断网络状况
function requestImage() {
  return new Promise((resolve) => {
    uni.request({
      url: 'https://travel.wujinbao.net/aa.jpg', // 以1M左右的图片测试请求时间
      success(res) {
        resolve(res)
      },
      fail(err) {
        resolve(err)
      },
    })
  })
}

// 更新全局是否有网络的值，并发送从无网络到有网络的通知, 页面执行刷新操作
function emitNetworkStatus(networkStatus) {
  const isOffline = networkStatus === NETWORK_STATUS.OFFLINE
  // 只有从无网络到有网络的才会对外发送。
  //   if (user.noNetwork !== networkStatus && isOffline) {
  //     EventBus.emit(eventNames.NET_WORK_CHANGE, isOffline)
  //   }
  //   user.setNoNetwork(isOffline) // offline时为无网络true，其他情况置于false
}

export default start
